/**
 * @name 密码最小长度
 */
export const PWD_MIN_LENGTH = 6;

export const PHONE_REG = /^1[3-9]\d{9}$/;

export const IMG_URL = 'https://cdn.jinweitec.com'

export const ERROR_ICON = IMG_URL + '/upload/20250520/462619f0d896f5a63c33e9607fbf5ffa.png';